(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["afro-header"]) return;
  try {
    
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const active = document.activeElement;
  const closest = active.closest('.afro-header details[open]');
  if (closest) {
    closest.open = false;
    closest.querySelector('summary').focus();
  }
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.afro-header details[open]').forEach((menu) => {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["afro-product-details"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const classify = (label) => {
      const text = normalize(label);
      if (text.includes('envio') || text.includes('embalagem')) return 'shipping';
      if (text.includes('gostar') || text.includes('beneficio')) return 'benefits';
      if (text.includes('como usar') || text.includes('utilizacao')) return 'usage';
      if (text.includes('cuidado') || text.includes('higienizacao') || text.includes('precauc')) return 'care';
      if (text.includes('tecnic') || text.includes('detalhes') || text.includes('compatibilidade') || text.includes('ingrediente') || text.includes('composicao')) return 'specs';
      return null;
    };
    const enhance = (root) => {
      if (root.dataset.accordionsReady) return;
      root.dataset.accordionsReady = 'true';
      const intro = root.querySelector('.afro-product-details__intro');
      const shipping = root.querySelector('[data-afro-shipping]');
      if (!intro || !shipping) return;
      const sources = new Map();
      let target = null;
      Array.from(intro.childNodes).forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE && node.matches('details')) {
          const summary = node.querySelector(':scope > summary');
          const key = classify(summary?.textContent || '');
          if (key) {
            if (key !== 'shipping') {
              const fragment = sources.get(key) || document.createDocumentFragment();
              Array.from(node.childNodes).filter((child) => child !== summary).forEach((child) => fragment.append(child));
              sources.set(key, fragment);
            }
            node.remove();
            target = null;
            return;
          }
        }
        if (node.nodeType === Node.ELEMENT_NODE) {
          const heading = node.matches('h2,h3,h4') || (node.matches('p') && node.children.length === 1 && node.firstElementChild.matches('strong,b'));
          const key = heading && classify(node.textContent);
          if (key) {
            target = key;
            node.remove();
            return;
          }
        }
        if (target) {
          if (target === 'shipping') node.remove();
          else {
            const fragment = sources.get(target) || document.createDocumentFragment();
            fragment.append(node);
            sources.set(target, fragment);
          }
        }
      });
      if (!sources.has('benefits') && !root.querySelector('[data-afro-key="benefits"]') && intro.textContent.trim()) {
        const fragment = document.createDocumentFragment();
        Array.from(intro.childNodes).forEach((node) => fragment.append(node));
        sources.set('benefits', fragment);
      }
      root.querySelectorAll('template[data-afro-tab]').forEach((template) => {
        const key = template.dataset.afroTab;
        const existing = Array.from(root.querySelectorAll('.afro-product-details__item')).find((item) => item.dataset.afroKey === key);
        if (existing) return;
        const content = sources.get(key);
        const item = template.content.firstElementChild.cloneNode(true);
        const body = item.querySelector('.rte');
        if (content && content.textContent.trim()) body.replaceChildren(content);
        if (!body.textContent.trim()) return;
        shipping.before(item);
      });
    };
    const initialize = (scope) => scope.querySelectorAll('.afro-product-details').forEach(enhance);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
